<template>
  <div class="card mt-3" style="height: fit-content;width: 100%;">
    <div class="card w-100 h-100" style="background-color: #edeaf2">
      <div class="d-flex w-100 h-100 py-2 ">
        <div style="width: 20% ; height: 100%" class="d-flex align-items-center ">
          <p class="font-weight-boldest ml-5" style="margin-bottom: 0; font-size: 13px">{{label}}</p>
        </div>
        <div class="d-flex  " style="width: 100%;">
          <el-input :value="displayValue" placeholder="Nhận xét" style="width: 100%" disabled></el-input>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectOptionKidView",
  props: {
    label: {
      type: String,
      default: ''
    },
    className: {
      type: String,
      default: ''
    },
    markValue: {
      type: Object,
    },
    placeholder: {
      type: String,
      default: ''
    },
    eName: {
      type: String
    }
  },
  computed: {
    displayValue() {
      if (!this.markValue || !this.eName) return '';
      const v = this.markValue[this.eName];
      return v == null ? '' : String(v);
    }
  }
}
</script>

<style scoped>
</style>


